import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { Order } from "../models/orders/order";
import { OrderService } from "../services/order/order.service";
import { inject } from "@angular/core";

export const orderResolver: ResolveFn<Order> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	return inject(OrderService).get(route?.params?.['orderId']);
}
